import {
  Box,
  CircularProgress,
  FormControlLabel,
  Grid,
  LinearProgress,
  Switch,
  Tooltip,
  Typography,
  IconButton,
} from "@mui/material";
import Button from "@mui/material/Button";
import axios from "axios";
import cogoToast from "cogo-toast";
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import { MdDelete } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom"; // Import useNavigate
import Select from "react-select";
import { fileLength } from "../app/features/counterSlice";
import uploadLogo from "../asstes/upload.png";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CustomizedSnackbars from "../components/CustomizedSnackbars";
import {
  AWS_Access_Key_Id,
  AWS_Access_Key_Id_Encypt,
  AWS_Bucket_Name,
  AWS_Region,
  AWS_Secret_Access_Key,
  AWS_Secret_Access_Key_Encypt,
} from "../constants/bucketCostant";
import {
  ClearCacheApi,
  FileLoader,
  LoginApi,
  UploadApi,
  keyImages,
  socket,
} from "../constants/Constants";
import "./Check.css";

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography
          variant="body2"
          color="text.secondary"
        >{`${props.value.toFixed(2)}%`}</Typography>
      </Box>
    </Box>
  );
}

function Check({ setTab, fetchStudies, isGrid, goBackGrid }) {
  const [files, setFiles] = useState([]);
  const [back, setBack] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [checkSpeed, setCheckSpeed] = useState(true);
  const [message, setMessage] = useState("");
  const [showCircular, setShowCircular] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [progressPercent, setProgressPercent] = useState(0);
  const [respArray, setRespArray] = useState(0);
  const [chunkedFilesLength, setChunkedFilesLength] = useState(0);
  const [isDeidentification, setisDeidentification] = useState(false);
  const [showGoBackButton, setShowGoBackButton] = useState(false);
  const [responseEstimate, setResponseEstimate] = useState(false);
  const [FolderList, setFolderList] = React.useState([]);
  const [failedFiles, setFailedFiles] = React.useState([]);
  let hasFailedFiles = false;
  const [SubFolderList, setSubFolderList] = useState([]);
  const [ThirdSubFolderList, setThirdSubFolderList] = useState([]);
  const [selectedFolder, setselectedFolder] = React.useState("");
  const FolderGet = useSelector((state) => state.FolderGet.FolderName);
  const [SubselectedFolder, setSubselectedFolder] = useState();
  const state = useSelector((state) => state.user);
  const [loading, setloading] = useState(false);
  const [divid, setdivid] = useState(false);
  const [UploadLoading, setUploadLoading] = useState(false);
  const [filecheck, setFilecheck] = useState(0);
  const [fileCount, setCount] = useState(0);
  const dispatch = useDispatch();
  const [totalsize, setTotalSize] = useState(0);
  const [targetTimes, setTargetTime] = useState({ hours: null, minutes: null });
  const [timeRemaining, setTimeRemaining] = useState(0);
  const [disableSubFolder, setDisableSubFolder] = useState(true);
  const [dropzoneDisable, setDropzoneDisable] = useState(true);
  //console.log(dropzoneDisable,"dropzoneDisable");
  const [hasFinishedUploading, setHasFinishedUploading] = useState(false);
  const [identityLoader, setIdentityLoader] = useState(false);
  const [totalUpload, setTotalUpload] = useState(0);
  const [uploadedstudyuid, setuploadedstudyuid] = useState([]);

  let aa = useParams();

  const { modality, FolderName, ssuid, subFolder, thirdFolder, fourthFolder } =
    useParams();
  const child = subFolder?.split("%");
  const MainFolder = FolderName?.split("%");
  //  const MainFolder = FolderName?.split(" ").join("");

  const [speedInMbps, setSpeed] = useState(null);

  const [uploadToS3, setUploadToS3] = useState(false);

  const handleChange = (event) => {
    setUploadToS3(event.target.checked);
  };

  useEffect(() => {
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    if (connection) {
      const updateSpeed = () => {
        const newSpeed = connection.downlink;
        // alert()
        if (newSpeed > 0.5 && newSpeed > speedInMbps) {
          if (checkSpeed == true) {
            setSpeed(newSpeed);
          }
        }
      };

      updateSpeed(); // Initial check
      // Add event listener for changes in connection speed
      connection.addEventListener("change", updateSpeed);

      // Clean up the event listener when component unmounts
      return () => {
        connection.removeEventListener("change", updateSpeed);
      };
    }
  }, [speedInMbps, checkSpeed]);

  //   setTimeout(() => {
  //     //console.log("Delayed message updated after 2 seconds");
  //     setCheckSpeed(true);
  //   }, 60000); // 2000 milliseconds = 2 seconds

  useEffect(() => {
    if (files.length > 0) {
      const unloadCallback = (event) => {
        event.preventDefault();
        event.returnValue = "";
        return "";
      };

      window.addEventListener("beforeunload", unloadCallback);
      return () => window.removeEventListener("beforeunload", unloadCallback);
    }
  }, [files]);

  const validateFileType = (file) => {
    const allowedTypes = [".pdf", ".dicom", ".dcm", ".not"];
    const fileNameParts = file.name.split(".");
    const extension =
      fileNameParts.length > 1 ? fileNameParts.pop().toLowerCase() : "not";
    return allowedTypes.includes("." + extension);
  };

  useEffect(() => {
    FolderListGet();
  }, []);

  useEffect(() => {
    if (selectedFolder) {
      SubFolderGet();
    }
  }, [selectedFolder]);

  useEffect(() => {
    if (SubselectedFolder) {
      ThirdSubFolderGet();
    }
  }, [SubselectedFolder]);

  const FolderListGet = async () => {
    setloading(true);
    const token = localStorage.getItem("token");
    try {
      if (FolderGet) {
        if (typeof FolderGet == "string") {
          setFolderList([FolderGet]);
        } else {
          setFolderList(FolderGet);
        }
      } else {
        const response = await fetch(
          `${FileLoader}/fileloaderv1/files/GetFolderList/?awsAccessKeyId=${encodeURIComponent(
            AWS_Access_Key_Id_Encypt(),
          )}&awsSecretAccessKey=${encodeURIComponent(
            AWS_Secret_Access_Key_Encypt(),
          )}&bucketName=${AWS_Bucket_Name()}&Region=${AWS_Region()}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
            headers: {
              Authorization: `Bearer ${token}`, // Replace 'yourAccessToken' with the actual access token
            },
          },
        );

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const GetFolderList = await response.json();
        ////console.log("Folder List:", GetFolderList);
        setFolderList(GetFolderList);
        if (response) {
          setloading(false);
        }
      }
      // Process folderList data as needed
      // Set state or perform any other actions with the folder data
    } catch (error) {
      setloading(false);
      //console.error("Error fetching folder data:", error);
    }
  };

  const sortedFolderList = FolderList.slice().sort((a, b) =>
    a.localeCompare(b),
  ); //sorted the elements according to their alphabatical orders
  const folderOptions = sortedFolderList
    .filter((value) => value !== "archive" && value !== "Multi") // Exclude unwanted folders
    .map((value) => ({
      value: value, // The value that will be used for submission
      label: value, // The text that will be displayed in the dropdown
    }));
  const subFolderOptions = SubFolderList.map((value) => ({
    value: value, // The value that will be used for submission
    label: value, // The text that will be displayed in the dropdown
  }));
  const thirdSubFolderOptions = ThirdSubFolderList.map((value) => ({
    value: value,
    label: value,
  }));
  const navigate = useNavigate(); // Use useNavigate hook for navigation
  const location = useLocation();

  // const desired_text = new URLSearchParams(window.location.href);
  var desired_text =
    location.pathname.includes("/SubFolder&studies/") &&
    location.pathname.slice(17);

  const goBack = () => {
    if (files?.length > 0) {
      let confirmExit = window?.confirm(
        "If you close this tab, the file upload will be interrupted. Are you sure you want to close this tab?",
      );
      if (confirmExit) {
        dispatch(fileLength(0));
        let destinationPath = "";

        if (FolderGet?.includes("/")) {
          navigate("/");
          setTab(0);
        } else if (
          location?.pathname?.includes(
            `/SubFolder&studies/${MainFolder}/${child}`,
          )
        ) {
          destinationPath = `/SubFolder&studies/${MainFolder}/${child}`;
        } else if (
          location?.pathname?.includes(`/SubFolder&studies/${FolderName}`)
        ) {
          destinationPath = `/SubFolder&studies/${FolderName}`;
        } else if (
          location?.pathname?.includes(`/StudyTable/${modality}/${MainFolder}`)
        ) {
          destinationPath = `/StudyTable/${modality}/${MainFolder}`;
        } else if (
          location?.pathname?.includes(`/SubFolder&studies/${selectedFolder}`)
        ) {
          destinationPath = `/SubFolder&studies/${
            selectedFolder ? selectedFolder : MainFolder
          }`;
        } else if (
          location?.pathname?.includes(
            `/StudyTable/${modality}/${selectedFolder}`,
          )
        ) {
          destinationPath = `/StudyTable/${modality}/${selectedFolder}`;
        } else if (
          location?.pathname?.includes(
            `/StudyTable/${MainFolder}/${modality}/${ssuid}`,
          )
        ) {
          destinationPath = `/StudyTable/${modality}/${MainFolder}`;
        } else if (
          location?.pathname?.includes(
            `/Upload/${MainFolder}/${modality}/${ssuid}`,
          )
        ) {
          destinationPath = `/SubFolder&studies/${MainFolder}`;
        } else if (
          location?.pathname?.includes(`/Upload/${MainFolder}/`)
          // location.pathname.includes(`${modality}/${ssuid}`) &&
          // location.pathname.includes(`/${child}/`)
        ) {
          destinationPath = `/SubFolder&studies/${MainFolder}`;
        } else if (location?.path?.includes(`/SubFolder&studies/`)) {
          destinationPath = `/SubFolder&studies/${MainFolder}`;
        }

        // Use navigate to go back to the determined destination only if the "Go Back" button is visible
        if (showGoBackButton && destinationPath) {
          navigate(destinationPath);
          setTab(4);
        }
      }
    } else {
      let destinationPath = "";

      if (FolderGet?.includes("/")) {
        navigate("/");
        setTab(0);
      } else if (
        location?.pathname?.includes(
          `/SubFolder&studies/${MainFolder}/${child}`,
        )
      ) {
        destinationPath = `/SubFolder&studies/${MainFolder}/${child}`;
      } else if (
        location?.pathname?.includes(`/SubFolder&studies/${FolderName}`)
      ) {
        destinationPath = `/SubFolder&studies/${FolderName}`;
      } else if (
        location?.pathname?.includes(`/StudyTable/${modality}/${MainFolder}`)
      ) {
        destinationPath = `/StudyTable/${modality}/${MainFolder}`;
      } else if (
        location?.pathname?.includes(`/SubFolder&studies/${selectedFolder}`)
      ) {
        destinationPath = `/SubFolder&studies/${
          selectedFolder ? selectedFolder : MainFolder
        }`;
      } else if (
        location?.pathname?.includes(
          `/StudyTable/${modality}/${selectedFolder}`,
        )
      ) {
        destinationPath = `/StudyTable/${modality}/${selectedFolder}`;
      } else if (
        location?.pathname?.includes(
          `/StudyTable/${MainFolder}/${modality}/${ssuid}`,
        )
      ) {
        destinationPath = `/StudyTable/${modality}/${MainFolder}`;
      } else if (
        location?.pathname?.includes(
          `/Upload/${MainFolder}/${modality}/${ssuid}`,
        )
      ) {
        destinationPath = `/SubFolder&studies/${MainFolder}`;
      } else if (
        location?.pathname?.includes(`/Upload/${MainFolder}/`)
        // location.pathname.includes(`${modality}/${ssuid}`) &&
        // location.pathname.includes(`/${child}/`)
      ) {
        destinationPath = `/SubFolder&studies/${MainFolder}`;
      } else if (location?.path?.includes(`/SubFolder&studies/`)) {
        destinationPath = `/SubFolder&studies/${MainFolder}`;
      }

      // Use navigate to go back to the determined destination only if the "Go Back" button is visible
      if (showGoBackButton && destinationPath) {
        navigate(destinationPath);
        setTab(4);
      }
    }
  };

  async function divideAndUpload(chunkedFiles, totalSizeInMB) {
    if (totalSizeInMB > 100) {
      for (const chunk of chunkedFiles) {
        let currentChunk = [];
        for (const item of chunk) {
          currentChunk.push(item);
          const currentSizeInMB =
            currentChunk.reduce((acc, file) => acc + file.size, 0) /
            (1024 * 1024);
          if (currentSizeInMB >= 100) {
            await uploadImages(currentChunk);
            currentChunk = [];
          }
        }
        // Upload any remaining files in the chunk
        if (currentChunk.length > 0) {
          await uploadImages(currentChunk);
        }
      }
    } else {
      // await EstimateTime();
      await uploadImages(chunkedFiles);
    }
  }

  const chunkSize = 150;
  const batches = async (isFailed = false) => {
    try {
      // if (files.length > 1500) {
      //   alert("You can upload 1500 files at a time");
      //   setFiles([]);
      // } else {
      function sliceIntoChunks(files) {
        const chunks = [];
        if (files.length === 1) {
          chunks.push(files);
        } else if (files.length <= chunkSize) {
          const half = Math.ceil(files.length / 2);
          chunks.push(files.slice(0, half));
          chunks.push(files.slice(half));
        } else {
          for (let i = 0; i < files.length; i += chunkSize) {
            const chunk = files.slice(i, i + chunkSize);
            chunks.push(chunk);
          }
        }

        // setChunkedFilesLength(chunks.length);
        return chunks;
      }
      var chunkedFiles = sliceIntoChunks(isFailed ? failedFiles : files);
      setFailedFiles([]);

      hasFailedFiles = false;

      let totalSize = 0;
      for (let i = 0; i < chunkedFiles.length; i++) {
        // totalSize += chunkedFiles[i][0].size;
        for (let j = 0; j < chunkedFiles[i].length; j++) {
          totalSize += chunkedFiles[i][j].size;
        }
        // //console.log(chunkedFiles[i], "Files name check here batch");
      }
      const totalSizeInMB = totalSize / (1024 * 1024);

      if (ssuid != undefined) {
        apiCall(files);
      } else if (totalSizeInMB > 100) {
        setdivid(true);
        await divideAndUpload(chunkedFiles, totalSizeInMB);
      } else if (chunkedFiles.length > 1) {
        setdivid(false);
        for (const item of chunkedFiles) {
          await uploadImages(item);
        }
      } else {
        setdivid(false);
        // await EstimateTime();
        await uploadImages(chunkedFiles[0]);
        // //console.log("dadadadadadada");
      }
      // }
    } catch (error) {
      // Handle errors appropriately
      console.error("Error:", error);
    }
  };
  const deIdentificationBatches = async (newFile) => {
    try {
      // if (files.length > 1500) {
      //   alert("You can upload 1500 files at a time");
      //   setFiles([]);
      // } else {

      function sliceIntoChunks(files) {
        const chunks = [];

        for (let i = 0; i < files.length; i += chunkSize) {
          const chunk = files.slice(i, i + chunkSize);
          chunks.push(chunk);
        }

        // setChunkedFilesLength(chunks.length);
        return chunks;
      }

      var chunkedFiles = sliceIntoChunks(newFile);

      let totalSize = 0;
      for (let i = 0; i < chunkedFiles.length; i++) {
        // totalSize += chunkedFiles[i][0].size;
        for (let j = 0; j < chunkedFiles[i].length; j++) {
          totalSize += chunkedFiles[i][j].size;
        }
        // //console.log(chunkedFiles[i], "Files name check here batch");
      }
      const totalSizeInMB = totalSize / (1024 * 1024);

      if (ssuid != undefined) {
        apiCall(files);
      } else if (totalSizeInMB > 100) {
        setdivid(true);
        await divideAndUpload(chunkedFiles, totalSizeInMB);
      } else if (chunkedFiles.length > 1) {
        setdivid(false);
        chunkedFiles.map(async (item) => {
          // await EstimateTime();
          await uploadImages(item);
          // //console.log("dadadadadadada");
        });
      } else {
        setdivid(false);
        // await EstimateTime();
        await uploadImages(chunkedFiles[0]);
        // //console.log("dadadadadadada");
      }
      // }
    } catch (error) {
      // Handle errors appropriately
      console.error("Error:", error);
    }
  };

  const createMetadata = async () => {
    try {
      const base64 =
        AWS_Bucket_Name() +
        "^" +
        AWS_Access_Key_Id() +
        "^" +
        AWS_Secret_Access_Key() +
        "^" +
        "edmeodmdmmuuddoc";
      const base64String = btoa(base64);
      const folderPathCreateMetadata =
        `${MainFolder}${child ? "()" + child : ""}${
          thirdFolder ? "()" + thirdFolder : ""
        }${fourthFolder ? "()" + fourthFolder : ""}` + `()`;
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };
      uploadedstudyuid.forEach((id) => {
        axios.post(
          `${ClearCacheApi}/create_metadata?base64=${base64String}&region=${AWS_Region()}&StudyInstanceUID=${id}&folderPath=${folderPathCreateMetadata}`,
          undefined,
          {
            headers,
          },
        );
      });
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setProgressPercent(
      respArray / chunkedFilesLength
        ? (respArray / chunkedFilesLength) * 100
        : 0,
    );
    var progress =
      respArray / chunkedFilesLength
        ? (respArray / chunkedFilesLength) * 100
        : 0;

    if (progress >= 100) {
      // setMessage("Files Uploaded Succesfully.");
      // cogoToast.success("Files Uploaded Succesfully.", {
      //   position: "top-right",
      // });
      let destinationPath = `/SubFolder&studies/${
        !desired_text && !ssuid ? selectedFolder : MainFolder
      }${child ? "/" + child : ""}${thirdFolder ? "/" + thirdFolder : ""}${
        fourthFolder ? "/" + fourthFolder : ""
      }`;

      if (
        (fileCount >= files.length || totalUpload >= files.length) &&
        hasFinishedUploading &&
        failedFiles.length == 0
      ) {
      } else {
        cogoToast.info("Please wait while we complete the upload..", {
          position: "top-right",
        });
      }

      // setIsOpen(true);
      setTimeout(() => {
        // if (failedFiles.length != 0) {
        //   setFiles([]);
        //   setFiles(failedFiles);
        // }
        if (
          (fileCount >= files.length || totalUpload >= files.length) &&
          hasFinishedUploading &&
          failedFiles.length == 0
        ) {
          if (uploadToS3) {
            createMetadata();
          }
          const roomId = !desired_text && !ssuid ? selectedFolder : MainFolder;
          socket.emit("notification-send", { roomId });
          setRespArray(0);
          setChunkedFilesLength(0);
          setUploadLoading(false);
          navigate(destinationPath);
          setTab(4);
          setFiles([]);
          setShowCircular(false);
          // setFiles([]);
          setProgressPercent(0);
          dispatch(fileLength(0));
          fetchStudies();
        }
      }, 2000);
    }

    // cogoToast.error("File Not Upload",{position:'top-right'})
    // progress = 0;

    if (
      location.pathname?.includes(`/Upload`) ||
      location.pathname?.includes(`/Upload/`) ||
      location.pathname?.includes(`/StudyTable/`) ||
      location.pathname?.includes(`/SubFolder&studies/`)
    ) {
      setShowGoBackButton(true);
    } else {
      // `${MainFolder}/${subFolder}/${modality}/${ssuid}`+
      setShowGoBackButton(false);
    }
  }, [
    respArray,
    location.pathname,
    chunkedFilesLength,
    totalUpload,
    fileCount,
    hasFinishedUploading,
  ]);

  const OnFileChange1 = async () => {
    setIdentityLoader(true);

    let totalSize = 0;
    for (let i = 0; i < files.length; i++) {
      totalSize += files[i].size;
    }

    // Convert totalSize to MB
    const totalSizeInMB = totalSize / (1024 * 1024);

    // if (totalSizeInMB > 300) {
    //   //console.error("Total file size exceeds 300MB. Please reduce the size.");
    //   setFiles([]);
    // }
    let fromdata = new FormData();
    if (!desired_text && !ssuid) {
      if (!selectedFolder) {
        return;
      }
    }
    for (let i = 0; i < files.length; i++) {
      fromdata.append("files", files[i]);
    }
    fromdata.append("profileName", "default");
    fromdata.append("productName", "dcm");
    const axiosInstance = axios.create({
      baseURL: "https://app.dcmcloud.com/",
    });
    axiosInstance
      .post("/api/v1/rules", fromdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (data) => {
          //Set the progress value to show the progress bar
          ////console.log(Math.round((100 * data.loaded) / data.total));
          ////console.log(data);
        },
      })
      .then(async (response) => {
        ////console.log(response.data.buffers, ".data");
        var newFile = [];
        function urltoFile(url, filename, mimeType) {
          return fetch(url)
            .then(function (res) {
              return res.arrayBuffer();
            })
            .then(function (buf) {
              return new File([buf], filename, { type: mimeType });
            });
        }
        for (var i = 0; i < response.data.buffers.length; i++) {
          await urltoFile(
            `data:application/dicom;base64,${response.data.buffers[i]}`,
            `${new Date()}.dcm`,
            "application/dicom",
          ).then(function (file) {
            newFile.push(file);
          });
        }
        // ////console.log(newFile);
        setIdentityLoader(false);
        setFiles(newFile);
        deIdentificationBatches(newFile);
      })
      .catch(() => {
        cogoToast.error(`Failed to De-identifying Images`, {
          position: "top-right",
        });
        setIdentityLoader(false);
      });
  };

  const OnFileChangeFailed = async () => {
    ////console.log("OnFileChange1");
    setShowCircular(true);

    let totalSize = 0;
    for (let i = 0; i < files.length; i++) {
      totalSize += files[i].size;
    }

    // Convert totalSize to MB
    const totalSizeInMB = totalSize / (1024 * 1024);

    // if (totalSizeInMB > 300) {
    //   //console.error("Total file size exceeds 300MB. Please reduce the size.");
    //   setFiles([]);
    // }
    let fromdata = new FormData();
    if (!desired_text && !ssuid) {
      if (!selectedFolder) {
        return;
      }
    }
    for (let i = 0; i < files.length; i++) {
      fromdata.append("files", files[i]);
      //console.log(files[i].name, "Files name come here");
    }
    fromdata.append("profileName", "default");
    fromdata.append("productName", "dcm");
    const axiosInstance = axios.create({
      baseURL: LoginApi,
    });
    axiosInstance
      .post("/api/v1/rules", fromdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (data) => {
          //Set the progress value to show the progress bar
          ////console.log(Math.round((100 * data.loaded) / data.total));
          ////console.log(data);
        },
      })
      .then(async (response) => {
        ////console.log(response.data.buffers, ".data");
        var newFile = [];
        function urltoFile(url, filename, mimeType) {
          return fetch(url)
            .then(function (res) {
              return res.arrayBuffer();
            })
            .then(function (buf) {
              return new File([buf], filename, { type: mimeType });
            });
        }
        for (var i = 0; i < response.data.buffers.length; i++) {
          await urltoFile(
            `data:application/dicom;base64,${response.data.buffers[i]}`,
            `${new Date()}.dcm`,
            "application/dicom",
          ).then(function (file) {
            newFile.push(file);
          });
        }
        // ////console.log(newFile);
        setFiles(newFile);
        batches(false);
      });
  };

  const apiCall = async (filesss) => {
    setChunkedFilesLength((prevLength) => prevLength + 1);

    try {
      let token = localStorage.getItem("token");
      let headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const fileKeys = Object.keys(filesss);

      // Create an array of promises to upload each file
      const uploadPromises = fileKeys.map((key) => {
        const file = filesss[key];
        const reader = new FileReader();

        return new Promise((resolve, reject) => {
          reader.onload = async () => {
            try {
              const base64Data = reader.result.split(",")[1];

              const formData = {
                AwsBucket: AWS_Bucket_Name(),
                folderName: `${MainFolder}${child ? "/" + child : ""}${
                  thirdFolder ? "/" + thirdFolder : ""
                }${fourthFolder ? "/" + fourthFolder : ""}/${ssuid}/Reports`,
                base64: base64Data,
                filePath: `${MainFolder}${child ? "/" + child : ""}${
                  thirdFolder ? "/" + thirdFolder : ""
                }${fourthFolder ? "/" + fourthFolder : ""}`,
                SUID: ssuid,
              };

              const response = await axios.post(
                `${keyImages}/keyImages/v1/PdfNode/uploadPdf`,
                JSON.stringify(formData),
                { headers },
              );

              resolve(response);
            } catch (err) {
              reject(err);
            }
          };

          reader.onerror = (err) => reject(err);
          reader.readAsDataURL(file);
        });
      });

      // Wait for all uploads to complete
      const responses = await Promise.all(uploadPromises);

      setRespArray((respArray) => respArray + responses.length);
      dispatch(fileLength(0));
      setMessage("PDF(s) Uploaded successfully");

      const destinationPath = `/SubFolder&studies/${
        !desired_text && !ssuid ? selectedFolder : MainFolder
      }${child ? "/" + child : ""}${thirdFolder ? "/" + thirdFolder : ""}${
        fourthFolder ? "/" + fourthFolder : ""
      }`;

      navigate(destinationPath);
      setTab(4);
      setTimeout(() => {
        setIsOpen(false);
      }, 3000);
    } catch (error) {
      console.error("Error while uploading PDFs:", error);
    }
  };

  const uploadImages = async (filesss, sec) => {
    // EstimateTime();
    const token = localStorage.getItem("token");

    let responseTIME = responseEstimate;

    setUploadLoading(true);

    setHasFinishedUploading(false);
    setFilecheck(filesss?.length);
    setChunkedFilesLength(files.length);

    // //console.log(files.length, "lenghtlenghtlenghtlenght");
    if (filesss === undefined) {
      alert("Please Select Files");
      return; // Abort the function since no files were selected
    }
    if (!desired_text && !ssuid) {
      if (selectedFolder == "") {
        alert("Please Select Folder ");
        return;
      }
    }
    // //console.log(files, "files");

    let url;
    let loss = 0;
    setShowCircular(true);

    const formData = new FormData();

    Object.entries(filesss).map((item) => {
      formData.append("dicomFiles", item[1]);
    });

    // formData.append("Region", "us-east-1");
    formData.append("bucketName", AWS_Bucket_Name());

    formData.append("Region", AWS_Region());
    formData.append(
      "folderName",
      `${
        selectedFolder
          ? `${selectedFolder}${
              SubselectedFolder ? "/" + SubselectedFolder : ""
            }`
          : `${MainFolder}${child ? "/" + child : ""}${
              thirdFolder ? "/" + thirdFolder : ""
            }${fourthFolder ? "/" + fourthFolder : ""}`
      }`,
    );
    formData.append("UserName", state.email);
    formData.append(
      "LastUploadLocation",
      Intl.DateTimeFormat().resolvedOptions().timeZone,
    );

    let prevCount = 0;
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        // Add other necessary headers
      },
      // signal, // Pass the signal to the request options
      onUploadProgress: (progressEvent) => {
        //console.log(progressEvent, "progressEventprogressEventprogressEvent");
        const progress = Math.round(
          (progressEvent.loaded / progressEvent.total) * 100,
        );
        let remaining = progress - loss;
        let currentPercent = (filesss.length / 100) * progress - prevCount;
        prevCount = (filesss.length / 100) * progress;
        setRespArray((respArray) => respArray + currentPercent);
        if (progressEvent.loaded === progressEvent.total) {
          setCount((prev) => prev + filesss.length);
        }
        // setRespArray(progress);
        loss = progress;
      },
    };

    url = uploadToS3
      ? `${UploadApi}/apiUpload/upload-dicom`
      : `${UploadApi}/apiUpload/upload-local-dicom`;

    await axios
      .post(url, formData, config)
      .then((response) => {
        var responseTextArray = response.data;

        var dicomFileCount = responseTextArray?.DicomFilesUploaded;
        var notDicomFileCount = responseTextArray?.NonDicomFilesUloaded;
        let TotalFiles = dicomFileCount + notDicomFileCount;

        setuploadedstudyuid((prev) => {
          const incoming = responseTextArray?.uploadedStudyIds ?? [];

          // Merge + remove duplicates
          return Array.from(new Set([...prev, ...incoming]));
        });

        setTotalUpload((prev) => prev + TotalFiles);
        setHasFinishedUploading(true);

        if (notDicomFileCount > 0) {
          cogoToast.error(`${notDicomFileCount} Non DICOM Files Ignored.`, {
            position: "top-right",
          });
        }

        if (dicomFileCount > 0) {
          cogoToast.success(`${dicomFileCount} DICOM Files Uploaded.`, {
            position: "top-right",
          });
        }
        setCheckSpeed(true);
        // EstimateTime();
      })
      .catch((error) => {
        cogoToast.error(`Failed to upload`, {
          position: "top-right",
        });
        // setRespArray((prev) => prev + 100);
        //console.log(filesss, "filesssfilesss1235");
        if (!hasFailedFiles) {
          setCount((prev) => prev - filesss.length);
          setRespArray((prev) => prev - filesss.length);
        }
        hasFailedFiles = true;
        setFailedFiles((prev) => [...prev, ...filesss]);
        console.error(error);
        // Handle errors
      });
  };
  const EstimateTime = async () => {
    const token = localStorage.getItem("token");
    let responseTIME = await axios.post(
      `${FileLoader}/fileloaderv1/files/EstimateUploadTime?fileSizeInMB=${totalsize}&uploadSpeedInMbps=${speedInMbps}`,
      null,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          // Add other necessary headers
        },
      },
    );
    setResponseEstimate(responseTIME);
    const [hoursStr, minutesStr, secondsStr] = responseTIME?.data?.split(":");
    const [secondsPart, millisecondsPart] = secondsStr.split(".");
    const hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);
    const seconds = parseInt(secondsPart, 10);
    setTargetTime({ hours: hours, minutes: minutes, seconds: seconds });
  };
  useEffect(() => {
    if (totalsize !== 0) {
      // EstimateTime();
    }
  }, [speedInMbps]);

  const colourStylesNew = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#ededf5",
      border: "grey",
      width: "200px",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      color: "grey", // Default text color
      fontSize: "13px",
      backgroundColor: isDisabled
        ? undefined
        : isSelected
          ? "#662583"
          : "transparent",
      cursor: isDisabled ? "not-allowed" : "default",
      ":hover": {
        ...styles[":hover"],
        backgroundColor: !isDisabled && !isSelected ? "#662583" : undefined,
        color: "white", // Change text color to white when hovered
      },
      ":active": {
        ...styles[":active"],
        backgroundColor: !isDisabled
          ? isSelected
            ? "#662583"
            : data.color
          : undefined,
      },
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#ededf5",
      // border: "grey",
    }),
    placeholder: (styles) => ({
      ...styles,
      color: "grey",
    }),
  };

  const SubFolderGet = async () => {
    const token = localStorage.getItem("token");
    try {
      let response = await fetch(
        `${FileLoader}/fileloaderv1/files/GetSubFolder?awsAccessKeyId=${encodeURIComponent(
          AWS_Access_Key_Id_Encypt(),
        )}&awsSecretAccessKey=${encodeURIComponent(
          AWS_Secret_Access_Key_Encypt(),
        )}&bucketName=${AWS_Bucket_Name()}&folderName=${selectedFolder}&Region=${AWS_Region()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      let res = await response.json();
      const filteredRes = res.filter((element) => !element.includes("."));
      setSubFolderList(filteredRes);
    } catch (error) {
      console.log(error);
    }
  };

  const ThirdSubFolderGet = async () => {
    const token = localStorage.getItem("token");
    try {
      let response = await fetch(
        `${FileLoader}/fileloaderv1/files/GetSubFolder?awsAccessKeyId=${encodeURIComponent(
          AWS_Access_Key_Id_Encypt(),
        )}&awsSecretAccessKey=${encodeURIComponent(
          AWS_Secret_Access_Key_Encypt(),
        )}&bucketName=${AWS_Bucket_Name()}&folderName=${
          selectedFolder + "/" + SubselectedFolder
        }&Region=${AWS_Region()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      let res = await response.json();
      const filteredRes = res.filter((element) => !element.includes("."));
      setThirdSubFolderList(filteredRes);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (files?.length !== 0 && selectedFolder?.length > 0) {
      //check file length and selectedflder
      // debugger;
      // setDisableSubFolder(false);
      if (
        SubFolderList?.length !== 0 &&
        SubselectedFolder &&
        SubselectedFolder !== "false"
      ) {
        //folderlist length grater than 0 and !subselectedfolder than button disable
        setDisableSubFolder(false);
      } else if (SubFolderList?.length == 0) {
        //folderlist length 0 then button enable
        setDisableSubFolder(false);
      } else {
        setDisableSubFolder(true); //
      }
    } else {
      setDisableSubFolder(true);
    }
  }, [selectedFolder, SubFolderList, SubselectedFolder, files]);

  useEffect(() => {
    if (selectedFolder?.length > 0) {
      if (
        SubFolderList?.length !== 0 &&
        SubselectedFolder &&
        SubselectedFolder !== "false"
      ) {
        setDropzoneDisable(false);
      } else if (SubFolderList?.length == 0) {
        setDropzoneDisable(false);
      } else {
        setDropzoneDisable(true); //
      }
    } else if (MainFolder) {
      setDropzoneDisable(false);
    } else {
      setDropzoneDisable(true);
      cogoToast.error(`Please select a folder first`, {
        position: "top-right",
      });
    }
  }, [selectedFolder, SubFolderList, SubselectedFolder]);

  // useEffect(() => {
  //   if (dropzoneDisable == true) {
  //     cogoToast.error(`Please select a folder first`, {
  //     position: "top-right",
  //   });
  //   }
  // }, [dropzoneDisable]);
  function calculateTimeRemaining(targetTimeString) {
    const targetTime = new Date();
    targetTime.setHours(targetTimeString?.hours);
    targetTime.setMinutes(targetTimeString?.minutes);
    targetTime.setSeconds(targetTimeString?.seconds);
    const now = new Date();

    let timeDiff = now.getTime() - targetTime.getTime();
    if (timeDiff < 0) {
      return {
        hours: 0,
        minutes: 0,
        seconds: 0,
        // milliseconds: 0,
      };
    }

    // const hoursRemaining = Math.floor(timeDiff / 36000000);
    // const remainingSecondsAfterHours = timeDiff % 3600000;
    // const minutesRemaining = Math.floor(remainingSecondsAfterHours / 60);
    // const secondsRemaining = remainingSecondsAfterHours % 60;

    const hoursRemaining = Math.floor(timeDiff / (10000 * 60 * 60));
    timeDiff -= hoursRemaining * (10000 * 60 * 60);
    const minutesRemaining = Math.floor(timeDiff / (10000 * 60));
    timeDiff -= minutesRemaining * (10000 * 60);
    const secondsRemaining = Math.floor(timeDiff / 10000);
    const millisecondsRemaining = timeDiff % 10000;

    setTargetTime({
      hours: hoursRemaining,
      minutes: minutesRemaining,
      seconds: secondsRemaining,
    });

    return {
      hours: hoursRemaining,
      minutes: minutesRemaining,
      seconds: secondsRemaining,
      milliseconds: millisecondsRemaining,
    };
  }

  return (
    <div>
      <Grid
        className=" flex my-grid mx-auto gap-2 lg:gap-0 md:gap-0 sm:gap-0"
        container
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // flexDirection: "column",
        }}
      >
        {!desired_text && !ssuid ? (
          <div className="w-[88%] d-flex justify-content-start gap-3">
            <div className="flex justify-center text-xs lg:text-base md:text-base sm:text-base">
              <label className="p-1">Select folder </label>
              <Select
                name="Select Folder"
                styles={colourStylesNew} // Replace with your custom styles
                placeholder="Select Folder"
                options={folderOptions} // The updated options array
                className="FontFamilyGilroy"
                isSearchable
                onChange={(selectedOption) =>
                  setselectedFolder(selectedOption ? selectedOption.value : "")
                } // Handling change
              />
              {/* <select
                className="border-2"
                onChange={(e) => {
                  setselectedFolder(e.target.value);
                }}
                style={{
                  marginBottom: "10px",
                  padding: "5px",
                  borderRadius: "10px",
                }}
              >
                <option value="">
                  {loading ? "Loading..." : <p>---Select Folder---</p>}
                </option>
                {sortedFolderList.map(
                  (value, index) =>
                    value != "archive" &&
                    value != "Multi" && (
                      <option key={index} value={value}>
                        {value}
                      </option>
                    )
                )}
              </select> */}
            </div>
            {SubFolderList.length != 0 && (
              <div className="flex justify-center text-xs lg:text-base md:text-base sm:text-base">
                <label className="p-1">Select Sub folder </label>
                <Select
                  name="Select Sub Folder"
                  styles={colourStylesNew} // Replace with your custom styles
                  placeholder="Select Folder"
                  options={subFolderOptions} // The updated options array
                  className="FontFamilyGilroy"
                  onChange={(selectedOption) =>
                    setSubselectedFolder(
                      selectedOption ? selectedOption.value : "",
                    )
                  } // Handling change
                />
                {/* <select
                  className="border-2"
                  onChange={(e) => {
                    setSubselectedFolder(e.target.value);
                  }}
                  style={{
                    marginBottom: "10px",
                    padding: "5px",
                    borderRadius: "10px",
                  }}
                >
                  <option value={false}>Select Sub Folder</option>
                  {SubFolderList?.map((value, index) => (
                    <option key={index} value={value}>
                      {value}
                    </option>
                  ))}
                </select> */}
              </div>
            )}
          </div>
        ) : null}
        {targetTimes?.minutes && failedFiles?.length == 0 && (
          <div className={`my-wrap ${isGrid ? "" : "mr-44"}`}>
            <p>
              Estimate time to Upload :{targetTimes?.hours} hour{" "}
              {targetTimes?.minutes} minutes
            </p>
          </div>
        )}
        {failedFiles?.length !== 0 && (
          <div className={`my-wrap ${isGrid ? "" : "mr-44"}`}>
            <p style={{ color: "red" }}>
              {failedFiles?.length} Files were failed to Upload Due to network
              Error if you want to retry Click{" "}
              <a style={{ color: "blue" }} onClick={() => batches(true)}>
                here
              </a>{" "}
              .
            </p>
          </div>
        )}

        <label
          className={`label123 w-[88%] h-[80%] ${
            isGrid ? "lg:h-[86%]" : "lg:h-1/2"
          } md:h-1/2 sm:h-1/2`}
          htmlFor="file"
        >
          <Dropzone
            className="upload-dropzone"
            onDrop={(acceptedFiles) => {
              // debugger
              // console.log("Accepted files:", acceptedFiles);
              let totalSize = 0;
              for (let i = 0; i < acceptedFiles.length; i++) {
                totalSize += acceptedFiles[i].size;
              }
              // Convert totalSize to MB
              const totalSizeInMB = totalSize / (1024 * 1024);
              setTotalSize((prev) => prev + totalSizeInMB);

              // if (totalSizeInMB > 300) {
              //   console.error(
              //     "Total file size exceeds 300MB. Please reduce the size."
              //   );
              //   setFiles([]);
              // }

              if (ssuid !== undefined) {
                const validFiles = acceptedFiles.filter(validateFileType);
                setFiles((prevFiles) => [...prevFiles, ...validFiles]);
                const filesLength = files.length + validFiles.length;
                dispatch(fileLength(filesLength));
              } else {
                const validFiles = acceptedFiles.filter(validateFileType);
                setFiles((prevFiles) => [...prevFiles, ...validFiles]);
                const filesLength = files.length + validFiles.length;
                dispatch(fileLength(filesLength));
              }
            }}
            disabled={dropzoneDisable || UploadLoading}
            accept=".pdf,.dicom"
          >
            {({ getRootProps, getInputProps }) => (
              <section className="custom-section" style={{ height: "100%" }}>
                <div {...getRootProps()} style={{ height: "100%" }}>
                  <input
                    accept=".pdf,.dicom"
                    style={{ zIndex: 99999999999 }}
                    // onClick={(e) => {
                    //   // Ensure that the input is clickable and handle issues in production.
                    //   console.log("Input clicked", e);
                    // }}
                    {...getInputProps()}
                    // onChange={() => {
                    //   debugger
                    //   console.log("console herer")
                    //   let totalSize = 0;
                    //   for (let i = 0; i < files.length; i++) {
                    //     totalSize += files[i].size;
                    //   }
                    //   // Convert totalSize to MB
                    //   const totalSizeInMB = totalSize / (1024 * 1024);

                    //   // if (totalSizeInMB > 300) {
                    //   //   console.error(
                    //   //     "Total file size exceeds 300MB. Please reduce the size."
                    //   //   );
                    //   //   setFiles([]);
                    //   // }
                    // }}
                  />
                  <Grid
                    className={`abc123 ${isGrid ? "width-set" : ""} `}
                    item
                    container
                    md={12}
                    style={{
                      textAlign: "center",
                      padding: "10px",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexDirection: "column",
                      border: "2px dashed #d9d9d9",
                      borderRadius: "8px",
                      background: "#fafafa",
                      cursor: "pointer",
                    }}
                  >
                    <p>
                      <img src={uploadLogo} width="78px" />
                    </p>
                    <Typography variant="h7">
                      <b style={{ color: "#605369" }}>
                        {UploadLoading
                          ? `Your ${
                              ssuid ? "Document is" : "DICOM files are"
                            } uploading, please wait a moment.`
                          : `Click to this area to select${" "}
                        ${ssuid ? "Document" : "DICOM files."}`}
                      </b>
                    </Typography>
                    <p style={{ color: "grey", fontSize: "12px" }}>
                      Support for a single or bulk upload. Strictly prohibit
                      from uploading company data or other band files
                    </p>
                  </Grid>
                </div>
              </section>
            )}
          </Dropzone>
        </label>
        <div
          id="progress_bar"
          className="progress-bar"
          style={{
            backgroundColor: "#3c40ef",
            width: "0%",
          }}
        >
          <span
            className="sr-only"
            id="sr_only"
            style={{ color: "#ffffff" }}
          ></span>
        </div>
        {showCircular ? (
          <div style={{ width: "74%" }}>
            <Box sx={{ width: "100%", boxShadow: "none", border: "none" }}>
              <LinearProgressWithLabel
                value={progressPercent > 100 ? 100 : progressPercent}
              />
            </Box>
          </div>
        ) : (
          <></>
        )}

        <div
          className="up-wrapper"
          style={{ marginTop: isGrid ? "0rem" : "-4rem" }}
        >
          {/* {!ssuid ? (
            <div className="class-wrap">
              <input
                type="checkbox"
                value={isDeidentification}
                id="flexCheckDefault"
                onChange={(e) => setisDeidentification(e.target.checked)}
              />
              <label style={{ display: "flex", marginLeft: "4px" }}>
                Image De-Identification
              </label>
            </div>
          ) : null} */}

          <div className="my-wrap">
            {UploadLoading ? (
              <div className="flex justify-center items-center -mb-8  ">
                <div
                  class="flex p-2 pl-3 text-sm text-blue-800 rounded-lg bg-blue-50  "
                  role="alert"
                >
                  {"  " + fileCount > files.length
                    ? files.length + " Files are uploaded "
                    : fileCount + " Files are uploaded "}
                  out of {files.length}
                  <CircularProgress
                    className="mx-3"
                    color={"inherit"}
                    style={{ height: "20px", width: "20px" }}
                  />
                </div>
              </div>
            ) : identityLoader ? (
              <div className="flex justify-center items-center -mb-8  ">
                <div
                  class="flex p-2 px-3 text-sm text-blue-800 rounded-lg bg-blue-50  "
                  role="alert"
                >
                  <CircularProgress
                    className="mr-3"
                    color={"inherit"}
                    style={{ height: "20px", width: "20px" }}
                  />
                  {" De-Identifying Images "}
                </div>
              </div>
            ) : (
              files?.length !== 0 && (
                <label style={{ display: "flex" }}>
                  <p style={{ marginBottom: "0px", color: "grey" }}>
                    Number of selected files :
                  </p>
                  <p style={{ marginBottom: "0px", color: "grey" }}>
                    {files.length}
                  </p>
                  <p onClick={() => setFiles([])}>
                    <Tooltip title="Clear selection">
                      {""}
                      <MdDelete className="m-1 cursor-pointer" />
                    </Tooltip>
                  </p>
                </label>
              )
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "5",
            // width: "30%",
          }}
          className={
            isGrid
              ? "lg:w-[65%] md:w-[45%]  sm:w-[45%] w-[50%]"
              : "w-[42%] lg:w-[35%]  md:w-[30%]  sm:w-[30%]"
          }
        >
          {/* Add a back arrow button */}
          {showGoBackButton && !isGrid && (
            //  Back button
            <Button
              className="text-xs md:text-base"
              variant="contained"
              onClick={isGrid ? goBackGrid : goBack}
              // style={{
              //   // margin: "15px",
              //   padding: "2px",
              //   background: "#5284c3",
              //   border: "1px solid #d9d9d9",
              //   cursor: "pointer",
              //   color: "#fff",
              //   height: "40px",
              //   width: "100px",
              // }}
            >
              <b>Back</b>
            </Button>
          )}

          {/* upload file button */}
          {!showGoBackButton ? (
            !UploadLoading ? (
              <Button
                className="text-xs md:text-base ml-2"
                variant="contained"
                onClick={
                  isDeidentification ? OnFileChange1 : () => batches(false)
                }
                disabled={disableSubFolder}
              >
                <b>Upload Files</b>
              </Button>
            ) : null
          ) : !UploadLoading ? (
            <Button
              className="text-xs md:text-base ml-2"
              variant="contained"
              onClick={
                isDeidentification ? OnFileChange1 : () => batches(false)
              }
              // disabled={files.length > 0 && !showCircular && selectedFolder.length > 0 && !disableSubFolder ? false : true}
              disabled={files.length == 0 ? true : false}
            >
              <b>Upload Files</b>
            </Button>
          ) : null}
          {!showGoBackButton ? (
            !UploadLoading ? (
              // <FormControlLabel
              //   className="text-xs ml-2"
              //   control={
              //     <Switch
              //       checked={uploadToS3}
              //       onChange={handleChange}
              //       color="primary"
              //       disabled={disableSubFolder}
              //     />
              //   }
              //   label={
              //     <span className="flex items-center gap-1">
              //       Upload to Storage 2
              //       <Tooltip
              //         title={
              //           "By default, Storage 1 (the server’s local file system) is used. Toggle this option to upload files to Storage 2 (AWS S3)."
              //         }
              //         arrow
              //         placement="top"
              //       >
              //         <IconButton size="small">
              //           <InfoOutlinedIcon fontSize="inherit" />
              //         </IconButton>
              //       </Tooltip>
              //     </span>
              //   }
              // />
              <></>
            ) : null
          ) : !UploadLoading ? (
            // <FormControlLabel
            //   className="text-xs ml-2"
            //   control={
            //     <Switch
            //       checked={uploadToS3}
            //       onChange={handleChange}
            //       color="primary"
            //       disabled={disableSubFolder}
            //     />
            //   }
            //   label={
            //     <span className="flex items-center gap-1">
            //       Upload to Storage 2
            //       <Tooltip
            //         title={
            //           "By default, Storage 1 (the server’s local file system) is used. Toggle this option to upload files to Storage 2 (AWS S3)."
            //         }
            //         arrow
            //         placement="top"
            //       >
            //         <IconButton size="small">
            //           <InfoOutlinedIcon fontSize="inherit" />
            //         </IconButton>
            //       </Tooltip>
            //     </span>
            //   }
            // />
            <></>
          ) : null}
        </div>
      </Grid>
      <CustomizedSnackbars
        isOpen={isOpen}
        severity={severity}
        message={message}
      />
    </div>
  );
}

export default Check;
